import { useRouter } from "next/router";
import Head from "next/head";
import Layout from "../../components/layout";
import style from "./text_to_image_generator.module.scss";
import MagicBgInputBlock from "../../components/magic_bg_page/MagicBgInputBlock/MagicBgInputBlock";
import ExploreBlock from "../../components/magic_bg_page/ExploreBlock/ExploreBlock";
import GalleryBlock from "../../components/magic_bg_page/GalleryBlock/GalleryBlock";
import FAQMagicBg from "../../components/magic_bg_page/FAQMagicBg/FAQMagicBg";
import getCommonLocales from "../../locales/locales_common";
import getFaqLocales from "../../locales/locales_faq";
import getRemoveBgPageLocales from "../../locales/locales_remove_bg";
import getErrorLocales from "../../locales/locales_error";
import TryOurTools from "../../components/tryOurTools/tryOurTools";
import ExamplesWrapper from "../../components/examples/examplesWrapper/examplesWrapper";

export default function TextToImageGenerator({ image_url }) {
	const { locale, query } = useRouter();

	const dictionary = { ...getFaqLocales(locale), ...getCommonLocales(locale), ...getRemoveBgPageLocales(locale), ...getErrorLocales(locale) };

	let title = dictionary["Text to Image AI Generator Online - BgRem"];
	let description = dictionary["simple & fast text-to-image AI generator"];
	let ogTitle = title;
	let ogDescription = description;

	const pageLink = image_url ? `https://bgrem.ai/text-to-image-generator/?image_url=${image_url}` : "https://bgrem.ai/text-to-image-generator/";

	const seoImg = image_url ? image_url : "https://bgrem.ai/seo/og-text.jpg";

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/text-to-image-generator/`;
		} else {
			return `https://bgrem.ai/${locale}/text-to-image-generator/`;
		}
	};

	return (
		<Layout mainClassName={`remove_bg magic_bg`}>
			<Head>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={ogTitle} />
				<meta property="og:description" content={ogDescription} />
				<meta property="og:url" content={pageLink} />
				<meta property="og:image" content={seoImg} />
				<meta property="og:site_name" content="bgrem" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:section" content="text-to-image" />
				<meta name="twitter:title" content={ogTitle} />
				<meta name="twitter:description" content={ogDescription} />
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:image:src" content={seoImg} />
				<meta name="twitter:image" content={seoImg} />
				<link rel="canonical" href={getCanonicalLink(locale)} />
			</Head>
			<section className={`section magicBg ${style.magic_bg}`}>
				<MagicBgInputBlock dictionary={dictionary} query={query} />
				<ExamplesWrapper type={"text"} t={dictionary} />
				<ExploreBlock dictionary={dictionary} />
				<GalleryBlock dictionary={dictionary} />
				<FAQMagicBg dictionary={dictionary} />
				<TryOurTools t={dictionary} />
			</section>
		</Layout>
	);
}

export async function getServerSideProps(context) {
	const image_url = context.query.image_url || null;

	return {
		props: {
			image_url,
		},
	};
}
